import _ from 'underscore';
import { DeprecatedReactPlacePageActionsMenu } from '../../app/content/PlacePageActionsMenu';
import { IActionTarget } from '../../common/react/components/ActionsMenu';
import { IReactTranslateService } from '../../common/react/IReactTranslateService';
import { Set } from '../models/Set';
import { IActionButton } from '../../commonInfra/contentActions/ActionPanelInterfaces';
import { ActionContext, IActionContext } from './ActionContext';

export interface SubplaceWithActionButtonsScope<TItem, TDetailItem> extends ng.IScope {
  allowedActions: any;
  anyActionsAllowed?: () => boolean;
  availableAction: (action: IActionButton<TItem, TDetailItem>) => boolean;
  menuActions: IActionButton<TItem, TDetailItem>[];
  showActionMenu: () => boolean;
  actionButtonContext: ($event: JQueryEventObject) => IActionContext;
  actionMenuContext: (menuButton: () => JQuery) => IActionContext;
}

export interface IActionsMenuScope<TItem, TDetailItem> {
  actionsMenuProps: DeprecatedReactPlacePageActionsMenu.Props<TItem, TDetailItem>;
  showActionMenu: () => boolean;
}

export module ActionButtonsHelper {

  /**
   * Sets up the properties on the scope necessary for the Angular actions menu in the
   * Revision History data grid, as well as the actions menus on the Angular content thumbnails.
   */
  export function setupScopeForAngularActionsMenu<TItem, TDetailItem>(
      scope: SubplaceWithActionButtonsScope<TItem, TDetailItem>,
      actionButtons: IActionButton<TItem, TDetailItem>[]
  ) {
    scope.menuActions = actionButtons;
    scope.showActionMenu = () => _.any(scope.menuActions, scope.availableAction);
    scope.actionButtonContext = ActionContext.fromEvent;
    scope.actionMenuContext = (getButton: () => JQuery) => {
      return {
        scope: scope
      };
    };
  }

  /**
   * Sets up the properties on the scope necessary for the React actions menu in a subplace's
   * action bar, above the data grid.
   */
  export function setupScopeForActionsMenuInActionBar<TItem, TDetailItem>(opts: {
    scope: IActionsMenuScope<TItem, TDetailItem>;
    isActionAvailable: (action: IActionButton<TItem, TDetailItem>) => boolean;
    menuActions: IActionButton<TItem, TDetailItem>[];
    getActionTarget: () => IActionTarget<TItem, TDetailItem>;
    translate: IReactTranslateService;
  }) {
    opts.scope.showActionMenu = () => _.any(opts.menuActions, opts.isActionAvailable);
    opts.scope.actionsMenuProps = {
      translate: opts.translate,
      getActionTarget: opts.getActionTarget,
      actions: opts.menuActions,
      testId: 'action-menu-button'
    };
  }

  export function getActionTargetFn<TItem>(scope: ng.IScope, selectedItems: Set<TItem>): () => IActionTarget<TItem, {}> {
    return () => ({
      items: selectedItems,
      actionContext: { scope }
    });
  }

}
